import React from 'react';
import { css } from 'emotion';

function Prices() {
  return (
    <div className={style.container} id="preise">
      <div className={style.title}>Preise</div>
      <div className={style.priceContainer}>
        <div className={style.women}>
          <div className={style.subtitle}>Frauen</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen</div>
              <div className={style.line}>Waschen, Schneiden</div>
              <div className={style.line}>Waschen, Föhnen/Legen</div>
              <div className={style.line}>Trocken schneiden</div>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen (bis 12 Jahre)</div>
              <div className={style.line}>Trocken schneiden (bis 12 Jahre)</div>
              <div className={style.line}>Farbe Ansatz</div>
              <div className={style.line}>Farbe komplett</div>
              <div className={style.line}>Pflanzenfarbe</div>
              <div className={style.line}>Folienstr&auml;hnen</div>
              <div className={style.line}>Kammstr&auml;hnen</div>
              <div className={style.line}>Dauerwelle komplett</div>
              <div className={style.line}>Pflege</div>
              <div className={style.line}>Augenbrauen f&auml;rben</div>
              <div className={style.line}>Wimpern f&auml;rben</div>
              <div className={style.line}>Augenbrauen zupfen</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>ab 38,00 EUR</div>
              <div className={style.line}>ab 35,00 EUR</div>
              <div className={style.line}>ab 28,00 EUR</div>
              <div className={style.line}>ab 27,00 EUR</div>
              <div className={style.line}>ab 24,00 EUR</div>
              <div className={style.line}>ab 17,00 EUR</div>
              <div className={style.line}>ab 30,00 EUR</div>
              <div className={style.line}>ab 35,00 EUR</div>
              <div className={style.line}>ab 40,00 EUR</div>
              <div className={style.line}>ab 35,00 EUR</div>
              <div className={style.line}>ab 30,00 EUR</div>
              <div className={style.line}>ab 78,00 EUR</div>
              <div className={style.line}>ab 12,00 EUR</div>
              <div className={style.line}>ab 10,00 EUR</div>
              <div className={style.line}>ab 13,00 EUR</div>
              <div className={style.line}>ab 10,00 EUR</div>
            </div>
          </div>
        </div>
        <div className={style.men}>
          <div className={style.subtitle}>M&auml;nner</div>
          <div className={style.priceTable}>
            <div className={style.articleColumn}>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen</div>
              <div className={style.line}>Waschen, F&ouml;hnen, Stylen</div>
              <div className={style.line}>Trocken schneiden</div>
              <div className={style.line}>Waschen, Schneiden, F&ouml;hnen (bis 12 Jahre)</div>
              <div className={style.line}>Trocken schneiden (bis 12 Jahre)</div>
              <div className={style.line}>Farbe komplett</div>
              <div className={style.line}>Folienstr&auml;hnen</div>
              <div className={style.line}>Kammstr&auml;hnen</div>
              <div className={style.line}>Dauerwelle komplett</div>
              <div className={style.line}>Haarwasser Kopfmassage</div>
              <div className={style.line}>Pflege</div>
              <div className={style.line}>Augenbrauen f&auml;rben</div>
              <div className={style.line}>Wimpern f&auml;rben</div>
              <div className={style.line}>Augenbrauen zupfen</div>
            </div>
            <div className={style.priceColumn}>
              <div className={style.line}>ab 25,00 EUR</div>
              <div className={style.line}>ab 20,00 EUR</div>
              <div className={style.line}>ab 22,00 EUR</div>
              <div className={style.line}>ab 20,00 EUR</div>
              <div className={style.line}>ab 17,00 EUR</div>
              <div className={style.line}>ab 30,00 EUR</div>
              <div className={style.line}>ab 25,00 EUR</div>
              <div className={style.line}>ab 25,00 EUR</div>
              <div className={style.line}>ab 65,00 EUR</div>
              <div className={style.line}>ab 15,00 EUR</div>
              <div className={style.line}>ab 12,00 EUR</div>
              <div className={style.line}>ab 10,00 EUR</div>
              <div className={style.line}>ab 13,00 EUR</div>
              <div className={style.line}>ab 10,00 EUR</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const style = {
  container: css`
    padding: 10px;
  `,
  title: css`
    font-size: 24px;
  `,
  priceContainer: css`
    display: flex;
    justify-content: space-between;
    @media (max-width: 920px) {
      flex-direction: column;
    }
  `,
  women: css`
    width: calc(50% - 20px);
    padding: 10px 15px 10px 5px;
    @media (max-width: 920px) {
      width: calc(100% - 10px);
      padding: 10px 5px;
    }
  `,
  men: css`
    width: calc(50% - 20px);
    padding: 10px 5px 10px 15px;
    @media (max-width: 920px) {
      width: calc(100% - 10px);
      padding: 10px 5px;
    }
  `,
  subtitle: css`
    font-size: 20px;
  `,
  priceTable: css`
    display: flex;
    justify-content: space-between;
    @media (max-width: 500px) {
      font-size: 14px !important;
    }
    @media (max-width: 460px) {
      font-size: 12px !important;
    }
    @media (max-width: 410px) {
      font-size: 11px !important;
    }
    @media (max-width: 360px) {
      font-size: 10px !important;
    }
  `,
  articleColumn: css`
    flex: 1;
  `,
  priceColumn: css``,
  line: css`
    padding: 2px 2px;
    &:nth-child(2n) {
      background-color: #f3f3f3;
    }
  `,
};

export default Prices;
